'use strict';
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const GroupApi = require('common/infra/api/group');
const Backbone = require('backbone');

module.exports = new (Backbone.Model.extend({
    initialize: function() {
        this._deferred = null;
        this._fetched = {};
    },

    fetchGroup: function(groupId) {
        return new Promise((resolve, reject) => {
            GroupApi.getGroup(groupId)
                .then(group => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_GROUP,
                        group: group
                    });
                    resolve();
                }, reject);
        });
    },

    fetchGroupOnce: function(groupId) {
        let promise = this._fetched[groupId];
        if(!promise) {
            promise = this.fetchGroup(groupId);
            this._fetched[groupId] = promise;
        }
        return promise;
    },

    fetchGroups: function(options) {
        const excludeMembers = options && options.excludeMembers;
        return new Promise((resolve, reject) => {
            GroupApi.getMyGroups({excludeMembers: excludeMembers})
                .then(groups => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_GROUP,
                        group: groups
                    });
                    resolve();
                }, reject);
        });
    },

    fetchGroupsOnce: function(options) {
        if(!this._deferred) {
            this._deferred = this.fetchGroups(options);
        }
        return this._deferred;
    },

    createGroup: function(params) {
        return new Promise((resolve, reject) => {
            GroupApi.create(params.group)
                .then(group => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_GROUP,
                        group: group
                    });
                    resolve(group);
                }, reject);
        });
    },

    updateGroup: function(params) {
        return new Promise((resolve, reject) => {
            GroupApi.update(params.group.id, params.group)
                .then(group => {
                    Dispatcher.dispatch({
                        type: Actions.UPDATE_GROUP,
                        group: group
                    });
                    resolve();
                }, reject);
        });
    },

    deleteGroup: function(params) {
        return new Promise((resolve, reject) => {
            GroupApi.delete(params.group.id)
                .then(() => {
                    Dispatcher.dispatch({
                        type: Actions.DELETE_GROUP,
                        group: params.group
                    });
                    resolve();
                }, reject);
        });
    }
}))();




// WEBPACK FOOTER //
// ./common/domain/action/group.js